import { OmniMaisV2RestService } from './../../omni-rest/omni-mais/omni-mais-v2-rest.service';
import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { AgenteEndereco } from './agente-endereco.interface';
import { Originador } from './originador.interface';

@Injectable()
export class AgenteService {

  constructor(private omniMaisRestService: OmniMaisV2RestService) { }

  getEnderecoAgentePorCep(cep: string, codeOriginador: number): Observable<AgenteEndereco> {
    return this.omniMaisRestService.get(`agent/destination/${codeOriginador}/${cep}`);
  }

  getOriginador(): Observable<Originador> {
    return this.omniMaisRestService.get('agent/originator');
  }

  getDestinationProposal(id: number): Observable<AgenteEndereco> {
    return this.omniMaisRestService.get(`agent/destination/proposal/${id}`);
  }

  getOriginatorProposal(id: number): Observable<AgenteEndereco> {
    return this.omniMaisRestService.get(`agent/originator/proposal/${id}`);
  }
}
